// extracted by mini-css-extract-plugin
export default {"main":"styles_main__AXycn","header":"styles_header__wvrVM","input":"styles_input__5Hp99","link":"styles_link__pzDav"};